enum CardVerificationMethod {
  Signature = 1,
  PinVerified = 2,
  CardholderNotPresent = 7,
  NoCVM = 8,
  UnknownCVM = 9,
  SignatureAndPin = 10
}

export default CardVerificationMethod;
